module.exports = __webpack_public_path__ + "img/circle.efbc8904.png";